/* eslint-disable */
export default {
    state: {
        isLoading: false
    }
}




// WEBPACK FOOTER //
// ./src/global/store/loadState.js